import classes from "./RoleDetailsCard.module.scss";
import { Card, Input, TextArea } from "@velocity-ehs/component-library";
import FormSkeleton from "../../../sharedComponents/FormSkeleton";
import { useTranslation } from "react-i18next";
import { CustomerRoleFormFields } from "../Utils";
import { UseFormReturn } from "react-hook-form";

interface RoleDetailsCardProps {
  isLoading?: boolean;
  formMethods: UseFormReturn<CustomerRoleFormFields, unknown>;
  readOnly?: boolean;
}

const RoleDetailsCard = ({
  isLoading = false,
  formMethods,
  readOnly,
}: RoleDetailsCardProps) => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = formMethods;

  return (
    <>
      <h1 className={classes.title}>{t("meta_role_details")}</h1>
      <Card showHeader={false} style={{ paddingBottom: "2px" }}>
        {isLoading ? (
          <FormSkeleton rows={5} />
        ) : (
          <>
            <Input
              control={control}
              label={t("universal_Name")}
              name="name"
              rules={{
                required: t("required_message_role_name"),
                maxLength: {
                  value: 100,
                  message: t("max_length_100_char_form_validation"),
                },
              }}
              errorMessage={errors && errors.name?.message}
              readOnly={readOnly}
            />
            <TextArea
              control={control}
              label={t("universal_Description")}
              name="description"
              rules={{
                required: t("required_message_description"),
              }}
              errorMessage={errors && errors.description?.message}
              readOnly={readOnly}
            />
          </>
        )}
      </Card>
    </>
  );
};

export { RoleDetailsCard };
